export const RemoveLessonMutation = `
mutation($orderedpostpartid: Int!) {
  DeleteVideo(orderedpostpartid: $orderedpostpartid) {
      success
   }
}`;
